var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThematicLogoSquare = function SvgThematicLogoSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 53 53"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 52.499,
    height: 52.499,
    fill: "url(#thematic-logo-square_svg__a)",
    fillOpacity: 0.33,
    rx: 12,
    style: {
      mixBlendMode: "soft-light"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52.499,
    height: 52.499,
    fill: "#080818",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFE",
    d: "M35.117 30.482v-10.74l3.684-1.754-12.577-5.913-3.65 1.7 3.97 1.894-8.716 4.24 4.349 2.034 8.42-4.345 4.506 2.15-4.299 2.003v11.04l-4.528 2.421V29.95l-8.473-4.283.026-5.756-4.18-1.962v15.299l4.114 2.34.023-4.978 8.492 4.609v5.206l12.572-7.133v-4.804z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "thematic-logo-square_svg__a",
    x1: 26.25,
    x2: 26.25,
    y1: 11.855,
    y2: 112.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADC1FF"
  })))));
};
export default SvgThematicLogoSquare;